import { Inject, Pipe, PipeTransform } from "@angular/core";
import * as momentImport from "moment-timezone";

import {
    TIME_FORMAT,
    TIMEZONE,
} from "../tokens/index";

const moment = momentImport as any; // required for rollup to work without a TypeScript error

@Pipe({ name: "spsTime" })
export class SpsTimePipe implements PipeTransform {
    constructor(
        @Inject(TIME_FORMAT) private timeFormat,
        @Inject(TIMEZONE) private timezone
    ) {}

    transform(time: any): string {
        if (!moment.isMoment(time)) {
            time = moment(time);
        }
        if (moment.defaultZone.abbrs.indexOf(time.zoneAbbr()) === -1) {
            time = time.clone().tz(this.timezone);
        }
        if (time.isValid()) {
            return time.format(this.timeFormat);
        }
    }
}
